"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const react_1 = require("react");
const tooltip_module_scss_1 = __importDefault(require("./tooltip.module.scss"));
const classnames_1 = __importDefault(require("classnames"));
const prop_types_1 = __importDefault(require("prop-types"));
const pattern_library_hooks_use_on_click_outside_1 = require("@saatva-bits/pattern-library.hooks.use-on-click-outside");
const useIsTouchScreenDevice_1 = __importDefault(require("./hooks/useIsTouchScreenDevice"));
const pattern_library_components_icon_1 = require("@saatva-bits/pattern-library.components.icon/");
const TooltipDialog_1 = __importDefault(require("./partials/TooltipDialog"));
const ToolTip = ({ className, isToolTipActive, bumperTop = '0', bumperRight = '0', bumperBottom = '0', bumperLeft = '0', children, isMobile, toggleToolTip, 
// below are passed directly to TooltipDialog
dialogWidth = '100%', dialogPinned, dialogClassName, toolTipTextBlocks, showMobileDialogCloseIcon, }) => {
    const tooltipRef = (0, react_1.useRef)(null);
    const dialogRef = (0, react_1.useRef)(null);
    const isTouchScreenDevice = (0, useIsTouchScreenDevice_1.default)();
    const handleToolTipToggle = (e, activeState) => {
        const tooltip = tooltipRef.current;
        const dialog = dialogRef.current;
        if (!dialog.contains(e.target)) {
            toggleToolTip(e, activeState, tooltip);
        }
    };
    (0, pattern_library_hooks_use_on_click_outside_1.useOnClickOutside)(tooltipRef, (e) => {
        if (isToolTipActive && isTouchScreenDevice) {
            handleToolTipToggle(e, false);
        }
    });
    const handleOnKeyDown = (e) => {
        switch (e.key) {
            case 'Enter':
            case ' ':
                handleToolTipToggle(e, !isToolTipActive);
                break;
            case 'Escape':
                handleToolTipToggle(e, false);
                break;
        }
    };
    const handleToolTipEvents = isTouchScreenDevice ? {
        onClick: (event) => {
            handleToolTipToggle(event, !isToolTipActive);
        }
    } : {
        onFocus: (event) => {
            handleToolTipToggle(event, true);
        },
        onBlur: (event) => {
            handleToolTipToggle(event, false);
        },
        onMouseEnter: (event) => {
            handleToolTipToggle(event, true);
        },
        onMouseLeave: (event) => {
            handleToolTipToggle(event, false);
        }
    };
    const toolTipProps = {
        role: 'tooltip',
        onKeyDown: handleOnKeyDown,
        ...handleToolTipEvents,
        className: (0, classnames_1.default)({
            [tooltip_module_scss_1.default['toolTip']]: true,
            [tooltip_module_scss_1.default['is-active']]: isToolTipActive,
            [tooltip_module_scss_1.default['toolTip__children']]: children,
        }, className),
        style: {
            marginTop: bumperTop,
            marginRight: bumperRight,
            marginBottom: bumperBottom,
            marginLeft: bumperLeft,
        },
    };
    const buttonClasses = (0, classnames_1.default)({
        [tooltip_module_scss_1.default['toolTip__button']]: true,
        [tooltip_module_scss_1.default['is-active']]: isToolTipActive,
    });
    const TooltipIcon = () => isToolTipActive && isTouchScreenDevice ? ((0, jsx_runtime_1.jsx)(pattern_library_components_icon_1.Icon, { name: "close", className: tooltip_module_scss_1.default['toolTip__close-icon'], description: "Hide Tool Tip", alt: "Hide Tool Tip", titleId: "Hide Tool Tip" })) : ((0, jsx_runtime_1.jsx)(pattern_library_components_icon_1.Icon, { name: "circleTooltip", className: tooltip_module_scss_1.default['toolTip__icon'], description: "Display Tool Tip", alt: "Display Tool Tip", titleId: "Display Tool Tip" }));
    const dialogProps = {
        isMobile,
        dialogWidth,
        isToolTipActive,
        dialogPinned,
        dialogClassName,
        toolTipTextBlocks,
        toggleToolTip,
        showMobileDialogCloseIcon
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isMobile &&
                (0, jsx_runtime_1.jsx)(TooltipDialog_1.default, { tooltipRef: tooltipRef, dialogRef: dialogRef, ...dialogProps }), (0, jsx_runtime_1.jsxs)("span", { ref: tooltipRef, ...toolTipProps, children: [!isMobile && ((0, jsx_runtime_1.jsx)(TooltipDialog_1.default, { tooltipRef: tooltipRef, dialogRef: dialogRef, ...dialogProps })), children ? ((0, jsx_runtime_1.jsx)("button", { "aria-label": "Toggle Tool Tip", children: children })) : ((0, jsx_runtime_1.jsx)("button", { type: "button", "aria-label": "Toggle Tool Tip", className: buttonClasses, children: (0, jsx_runtime_1.jsx)(TooltipIcon, {}) }))] })] }));
};
ToolTip.propTypes = {
    /** Applies a custom class to the ToolTip dialog trigger. */
    className: prop_types_1.default.string,
    /** Applies a custom class to the ToolTip dialog. */
    dialogClassName: prop_types_1.default.string,
    /** Add specific marging on top */
    bumperTop: prop_types_1.default.string,
    /** Add specific marging on bottom */
    bumperBottom: prop_types_1.default.string,
    /** Add specific marging on right */
    bumperRight: prop_types_1.default.string,
    /** Add specific marging on left */
    bumperLeft: prop_types_1.default.string,
    /** Pin ToolTip dialog */
    dialogPinned: prop_types_1.default.bool,
    /** ToolTip state */
    isToolTipActive: prop_types_1.default.bool.isRequired,
    /** Function to control ToolTip behaviour. Receives event object, next tooltip state and ToolTip dialog ref */
    toggleToolTip: prop_types_1.default.func.isRequired,
    /** ToolTip dialog text. */
    toolTipTextBlocks: prop_types_1.default.array.isRequired,
    /** Toggle showing an (x) icon on mobile tooltip dialogs */
    showMobileDialogCloseIcon: prop_types_1.default.bool,
    /** Content that will be rendered as children of the ToolTip component. */
    children: prop_types_1.default.any,
    /** Set mobile version for TolTip */
    isMobile: prop_types_1.default.bool,
    /** Applies a specific width to the Tooltip dialog. Only works when isMobile is true */
    dialogWidth: prop_types_1.default.string,
};
exports.default = ToolTip;
//# sourceMappingURL=tooltip.js.map